import "./Header.css"
import logo from "../images/logo.svg"
const Header = () => {
    return (
        <header>
            <div className="container">
                <nav className= "fx sb ai" >
                    <div className="nav__logo">
                    <img className= "fx  ai" src={logo}
                        alt = ""/>
                    </div>
                    <div className="nav__links">
                        <a href="#">Features</a>
                        <a href="#">Team</a>
                        <a href="#">Sign In</a>
                    </div>
                   
                </nav>
                
            </div>
        </header>
    )
}

export default Header
